import { render, staticRenderFns } from "./chat-attached-s3-file.vue?vue&type=template&id=e9bbdec6&scoped=true"
import script from "./chat-attached-s3-file.vue?vue&type=script&lang=js"
export * from "./chat-attached-s3-file.vue?vue&type=script&lang=js"
import style0 from "./chat-attached-s3-file.vue?vue&type=style&index=0&id=e9bbdec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bbdec6",
  null
  
)

export default component.exports